import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getLayerDefinitions } from '../../../services/map-layer';
import { mapBaseLayerDefinitions } from '../../../services/map-style';
import { setMapOptions } from '../../../services/store/modules/app-controls';
import {
  getSelectedLayers,
  switchLayer,
} from '../../../services/store/modules/map-settings';
import MarkerCircle from '../../shared/_deprecated/components/MarkerCircle/MarkerCircle';
import MapSettingsMarkerGroupContainerView from './components/MapSettingsMarkerGroupContainerView';

class MapSettingsMarkerGroupPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mapLayerMarkerTypes: undefined,
    };

    this.BASE_MAP_LAYER_DEFINITIONS = mapBaseLayerDefinitions;

    this.toggleSelectedLayerType = (layerName) => {
      const { selectedLayerTypes, dispatch } = this.props;
      let layerIsOn = false;

      if (selectedLayerTypes.indexOf(layerName) !== -1) {
        // Turn option OFF
      } else {
        // Turn option ON
        layerIsOn = true;
      }

      // Update the map settings
      dispatch(switchLayer({ name: layerName, enabled: layerIsOn }));
    };

    this.updateMarkerGroups = (menuType) => {
      const definitions = getLayerDefinitions();

      const mapLayerMarkerTypes = Object.keys(definitions)
        .filter(
          (layerName) =>
            definitions[layerName].menuOptions &&
            definitions[layerName].menuOptions.owningMenu === menuType,
        )

        .filter((layerName) => definitions[layerName].menuOptions.visible)
        .map((layerName) => {
          const {
            displayName,
            markerGroup,
            icon: { baseShape, iconColor, markerColor },
          } = definitions[layerName];

          return {
            layerName,
            displayName,
            markerGroup,
            menuIconNode: (
              <MarkerCircle
                iconConfig={{
                  baseShape,
                  iconColor,
                  markerColor,
                }}
                width={36}
                height={36}
              />
            ),
          };
        });

      this.setState({
        mapLayerMarkerTypes,
      });
    };
  }

  componentDidMount() {
    const { markerGroup, dispatchSetMapOptions } = this.props;

    dispatchSetMapOptions();

    this.updateMarkerGroups(markerGroup);
  }

  render() {
    const { mapLayerMarkerTypes } = this.state;

    const { selectedLayerTypes } = this.props;

    return (
      <MapSettingsMarkerGroupContainerView
        toggleSelectedLayerType={this.toggleSelectedLayerType}
        selectedLayerTypes={selectedLayerTypes}
        mapLayerMarkerTypes={mapLayerMarkerTypes}
      />
    );
  }
}

MapSettingsMarkerGroupPage.propTypes = {
  markerGroup: PropTypes.string.isRequired,
  dispatchSetMapOptions: PropTypes.func.isRequired,
  selectedLayerTypes: PropTypes.arrayOf(PropTypes.string),
};

MapSettingsMarkerGroupPage.defaultProps = {
  selectedLayerTypes: [],
};

const mapStateToProps = (state) => ({
  selectedLayerTypes: getSelectedLayers(state),
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  dispatchSetMapOptions: () => dispatch(setMapOptions({})),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MapSettingsMarkerGroupPage);
